<mat-card class="sx-tips-item">
    <mat-card-header>
        <mat-card-title>{{ tip.title }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        @if(tip?.tags){
            <div class="sx-tips-tags">
                @for(tag of tip.tags; track tag){
                    <div class="sx-chip">{{ tag }}</div>
                }
            </div>
        }
        <div [innerHtml]="tip.message | safeHtml" class="sx-tips-item-content"></div>
    </mat-card-content>
    <mat-card-actions>
        @if(tip?.url){
            <button mat-button id="tip_navigate_to_btn" (click)="onNavigateClick()">
                <span>{{ 'core.header.tips.navigate-to-button' | translate }}</span>
            </button>
        }
        @if(!tip.isRead){
            <button mat-button id="tip_hide_btn" (click)="onHideClick()">
                <span>{{ 'core.header.tips.hide-button' | translate }}</span>
            </button>
        }
    </mat-card-actions>
</mat-card>